define('viewmodels/RiskRating/RiskRatingConfiguration',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils) {

        var RRConfigVM = {
            activate: activate,
            attached: attached,
            detached: detached,
            logger: logger,
            appsecurity: appsecurity,

            // methods, events, popUps
            RRAreaTabClick: RRAreaTabClick,
            GetRRFactors: GetRRFactors,
            onChangeFetchAreas: onChangeFetchAreas,
            onChangeFetchFactors: onChangeFetchFactors,
            saveRRCategories: saveRRCategories,
            addRRItemPopUp: addRRItemPopUp,
            RunSyncScores: RunSyncScores,
            DrawMappingsTable: DrawMappingsTable,
            SyncratingsToInherent: SyncratingsToInherent,
            saveRRItem: saveRRItem,
            EditItemPopUp: EditItemPopUp,
            DeleteItemPopUp: DeleteItemPopUp,
            GetRiskSubFactors: GetRiskSubFactors,
            GetAllRiskSubFactor: GetAllRiskSubFactor,


            //observables
            RRAreaList: ko.observableArray([]),
            AreaLeveljstree: ko.observableArray([]),
            RRFactorList: ko.observableArray([]),
            SelectedFactorList: ko.observableArray([]),
            SelectedAreasList: ko.observableArray([]),
            SelectedMRRAreaId: ko.observable(),
            SelectedMRRAreaName: ko.observable(),
            ScreenName: ko.observable(),
            ButtonAdd: ko.observable(),
            TableItemName: ko.observable(),
            CurrentRiskFactorId: ko.observable(),
            RiskSubFactorsList: ko.observableArray(),
            TableItemDescription: ko.observable(),
            AssessmentTypeList: ko.observableArray([]),
            AssessmentTypeListEdit: ko.observableArray([]),
            SelectedAssessmentType: ko.observableArray([]),
            RRItemsList: ko.observableArray([]),
            RRItemsListDup: ko.observableArray([]),
            addPopUpCss: ko.observable(),
            popUpTitle: ko.observable(),
            editableRRItem: ko.observable(),
            EditRRItemFlag: ko.observable(),
            MainAttributeList: ko.observableArray([]),
            ClickedRRItemId: ko.observable(),
            selectedRATs: ko.observableArray([]),
            hasChildNodes: ko.observable(false),
            NavigationMenuHideShow: NavigationMenuHideShow,
            CollapseAllTreeView: CollapseAllTreeView,
        };

        return RRConfigVM;
        

        function activate() {
            try {
                //code
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                //code
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                GetAssessmentTypes();
             
              //  GetRRFactors();
                InitiateLevelTree();         
 
               
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#region Get Methods

        function GetRRAreas() {
            try {
                var RATIDs = "";
                for (var i = 0; i < RRConfigVM.SelectedAssessmentType().length; i++) {
                    if (RATIDs === "")
                        RATIDs += RRConfigVM.SelectedAssessmentType()[i];
                    else
                        RATIDs += "," + RRConfigVM.SelectedAssessmentType()[i];
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetRRAreas",
                    type: "GET",
                    headers: headers,
                    data: { "SelectedRAT": RATIDs }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                RRConfigVM.RRAreaList(jsonResult);
                                //var selectedAreaID = "";
                                //for (var i = 0; i < RRConfigVM.RRAreaList().length; i++) {
                                //    if (RRConfigVM.RRAreaList()[i].SelectedAreaId == 1) {
                                //        if (selectedAreaID === "")
                                //            selectedAreaID += RRConfigVM.RRAreaList()[i].MRRAId;
                                //        else
                                //            selectedAreaID += "," + RRConfigVM.RRAreaList()[i].MRRAId;
                                //    }
                                //    RRConfigVM.SelectedAreasList(selectedAreaID)
                                //}
                                $('#RRAreas').multiselect();
                                $('#RRAreas').multiselect('refresh');
                            }
                            if (jsonResult.length === 0) {
                                $('#loadingMainImgDiv').hide();
                           
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while deleting the assessment type. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetRRAreas() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function GetRRFactors(data) {
            try {
                var RATIDs = "";
                var AreaIDs = "";                
                for (var i = 0; i < data.SelectedAssessmentType().length; i++) {
                    if (RATIDs === "")
                        RATIDs += data.SelectedAssessmentType()[i];
                    else
                        RATIDs += "," + data.SelectedAssessmentType()[i];
                }
                for (var i = 0; i < data.SelectedAreasList().length; i++) {
                    if (AreaIDs === "")
                        AreaIDs += data.SelectedAreasList()[i];
                    else
                        AreaIDs += "," + data.SelectedAreasList()[i];
                }
               
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetRiskFactorsByArea",
                    type: "GET",
                    headers: headers,
                    data: {
                        "SelectedRAT": RATIDs,
                        "SelectedAreaId": AreaIDs
                    }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                RRConfigVM.RRFactorList(jsonResult);
                                $('#RRFactors').multiselect();
                                $('#RRFactors').multiselect('refresh');
                            }
                            if (jsonResult.length === 0) {
                                $('#loadingMainImgDiv').hide();
                             
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while deleting the assessment type. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetRRAreas() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function SyncratingsToInherent() {
            app.showMessage(" By clicking the <b> Confirm </b> button, I acknowledge the following: </b> \n <br> 1. I have reviewed the ratings available on this screen; \n <br> 2. The Risk Scores would sync with the PCS ratings in the Inherent Setup. If you do not wish to proceed, please click on <b> Deny</b>. \n", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                .then(function (option) {
                    if (option == 'Confirm') {
                        RunSyncScores();
                    }
                });
        }

        function RunSyncScores() {
            try {
               
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Calculation/RunSyncScoresRR?AssessmentProfile=" + appsecurity.CurrentProfileOfAssessmentId(),
                    headers: headers,
                    type: "POST"
                })
                    .success(function (jsonResult, error) {
                       
                        logger.logSuccess('Scored have been moved to Inherent section successfully', 'Success', system.getModuleId(RRConfigVM), true);
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while ruuning the calculations. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    });
            }
            catch (e) {

            }
        }

        function NavigationMenuHideShow(data) {
            try {
                if (data == "Hide") {
                    // Hides Area NavigationMenu
                    $('#HideNavMenu').hide();
                    $('#ShowNavMenu').show();
                    $('#FilterAreaAccordion').hide();
                    $("#bottomDivAreaType").removeClass("col-lg-9").addClass("col-lg-12");
                    // $(".rabrd").addClass("raBreadcrumb");

                }
                else {
                    // Shows Area NavigationMenu
                    $('#HideNavMenu').show();
                    $('#ShowNavMenu').hide();
                    $('#FilterAreaAccordion').show();
                    $("#bottomDivAreaType").removeClass("col-lg-12").addClass("col-lg-9");
                    // $(".rabrd").removeClass("raBreadcrumb");
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in NavigationMenuHideShow() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() == "Expand") {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text("Collapse");
                $("#arrowSpan").removeClass("fa-caret-right").addClass("fa-caret-down");
            }
            else {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text("Expand");
                $("#arrowSpan").removeClass("fa-caret-down").addClass("fa-caret-right");

            }
        }


        function GetAssessmentTypes() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetAssessmentTypes",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                var mappedAssessmentList = $.map(jsonResult, function (result) {
                                    return new AssessmentTypeModel(result);
                                });
                                  var selectedRATID = [];
                                RRConfigVM.SelectedAssessmentType([]);
                                for (var i = 0; i < jsonResult.length; i++) {
                                    if (jsonResult[i].SelectedAreaId == 1) {
                                        if (selectedRATID.length == 0)
                                            selectedRATID.push(jsonResult[i].AssessmentId);
                                        else
                                            selectedRATID.push(jsonResult[i].AssessmentId);
                                    }
                                }
                              
                              
                           //  RRConfigVM.SelectedAssessmentType(selectedRATID);
                               // RRConfigVM.SelectedAssessmentType.push(selectedRATID);
                                RRConfigVM.AssessmentTypeList(mappedAssessmentList);
                                $('#RRApplicability').multiselect();
                                $('#RRApplicability').multiselect('refresh');
                                //    RRConfigVM.SelectedAssessmentType.push(selectedRATID);
                                    GetRRAreas();
                                

                               
                            }
                            if (jsonResult.length === 0) {
                                $('#loadingMainImgDiv').hide();
                     
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while deleting the assessment type. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAssessmentTypes() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }



        function GetRiskSubFactors(FactorID) {
            try {
                GetAllRiskSubFactorAjax = {
                    url: "/api/RiskRatingConfiguration/GetRiskSubfactor",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    async: false,
                    data: {
                        "RiskFactorId": FactorID
                    }
                };
                GetAllRiskSubFactor(GetAllRiskSubFactorAjax);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetRiskFactors() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }

        function GetAllRiskSubFactor(GetAllRiskSubFactorAjax) {
            try {
                $.ajax(GetAllRiskSubFactorAjax)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != 'undefined' && jsonResult != null) {
                        if (jsonResult.length != 0) {

                            var mappedRiskFactors = $.map(jsonResult, function (result) {
                                return new RiskSubFactorModel(result);
                            });

                            tableObj = $('#subfactor').DataTable();
                            tableObj.destroy();
                            $("#subfactor tbody tr").remove();
                            RRConfigVM.RiskSubFactorsList(mappedRiskFactors);
                           
                            RfTableObj = $('#subfactor').DataTable({
                                responsive: true,
                                stateSave: true,
                                "ColumnDefs": [{
                                    "targets": [0],
                                    "visible": true,


                                    "className": "details-control"

                                }, {
                                    "targets": [1],
                                    "visible": false,
                                    "orderable": false

                                }, {
                                    "targets": [2],
                                    "visible": true
                                },
                                {
                                    "targets": [3],
                                    "orderable": true
                                }

                                ]
                            });
                            $('#subfactor').DataTable().draw(false);
                        }
                        else {
                            HmViewModel.RiskSubFactorList([]);
                            tableObj = $('#subfactor').DataTable();
                            tableObj.destroy();
                            $('#subfactor tbody tr').remove();
                            RfTableObj = $('#subfactor').DataTable({
                                responsive: true,
                                stateSave: true,
                                "ColumnDefs": [{
                                    "targets": [0],
                                    "visible": true,
                                    "className": "details-control"

                                }, {
                                    "targets": [1],
                                    "visible": false,
                                    "orderable": false

                                },
                                {
                                    "targets": [2],
                                    "visible": true
                                },
                                {
                                    "targets": [3],
                                    "orderable": true
                                }
                                ]
                            });
                            $('#subfactor').DataTable().draw(false);
                        }
                        $('#loadingMainImgDivFactors').hide();
                    }
                    else {
                        HmViewModel.RiskSubFactorList([]);
                       
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                    $('#loadingMainImgDivFactors').hide();
                }
            }

            function ajaxFail(error, status) {
                try {
                    $('#loadingMainImgDiv').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                    $('#loadingMainImgDivFactors').hide();
                }
            }
        }
        function GetAllRRItemsWithMappings() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetAllRRItemsWithMappings",
                    type: "GET",
                    headers: headers,
                    data: { "SelectedMRRAreaId": RRConfigVM.SelectedMRRAreaId() }
                })
                    .success(function (jsonResult, success) {
                        $('#loadingMainImgDiv').hide();
                        $('#ItemsDiv').show();
                        if (jsonResult !== null) {


                            tableObj = $('#tblItems').DataTable();
                            tableObj.destroy();
                            $('#tblItems tbody tr').remove();

                            var mappedList = $.map(jsonResult, function (result) {
                                return new RRItemModel(result);
                            });

                            RRConfigVM.RRItemsList(mappedList);

                            var mappedListDup = $.map(jsonResult, function (result) {
                                return new RRItemModel(result);
                            });
                            RRConfigVM.RRItemsListDup(mappedListDup);

                            $('#tblItems').DataTable({
                                "order": [],
                                "aaSorting": [],
                                "bResponsive": true,
                                "aoColumnDefs": [
                                    {
                                        "aTargets": [4],
                                        "bSortable": false
                                    }
                                ]
                            });
                            $('#tblItems').DataTable().draw(false);

                        }
                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while fetching the Risk Rating Items. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                        }
                    })

                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRRItemsWithMappings() method in RiskRatingConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllRRItemsWithMappings() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function GetAOMappingData() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetAOMappingData",
                    type: "GET",
                    headers: headers,
                    data: { "MRRAId": RRConfigVM.SelectedMRRAreaId()}
                })
                    .success(function (jsonResult, success) {

                        if (jsonResult !== null) {
                            RRConfigVM.MainAttributeList(jsonResult);
                            GetAllRRItemsWithMappings();
                        }
                        else {
                            logger.logError('Some error occured while fetching the Attribute Options Mapping Data. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                        }
                    })

                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAOMappingData() method in RiskRatingConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAOMappingData() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion


        //#region Events, TabClicks & Other Methods

        function onChangeFetchAreas(data, event) {
            try {
                GetRRAreas();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onChangeFetchAreas() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function onChangeFetchFactors(data, event) {
            try {
                GetRRFactors(data);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onChangeFetchAreas() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function RRAreaTabClick(data, event) {
            try {
                $('#loadingMainImgDiv').show();
                $('#ItemsDiv').hide();
                RRConfigVM.SelectedMRRAreaId(data.MRRAId);
                RRConfigVM.SelectedMRRAreaName(data.MRRAName);

                var RATArray = $.map(data.RATArray, function (result, index) {
                    return new AssessmentTypeModel(result, index);
                });

                RRConfigVM.AssessmentTypeList(RATArray);
                RRConfigVM.ScreenName(data.MRRAName + " Configuration");
                RRConfigVM.TableItemName(data.MRRAName + " Name");
                RRConfigVM.TableItemDescription(data.MRRAName + " Description");
                RRConfigVM.ButtonAdd("Add " + data.MRRAName);
                $('#lblRRAName').empty();
                document.getElementById('lblRRAName').innerHTML = data.MRRAName;
                $('#lblApplicability').empty();
                document.getElementById('lblApplicability').innerHTML = data.ApplicableRATNames;

                GetAOMappingData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRAreaTabClick() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function saveRRCategories(data, event) {
            try {
                $('#valErrorRRItem').hide();

                if (RRConfigVM.SelectedAreasList().length == 0) {
                    $('#valErrorRRItem').show();
                    $('#valErrorRRItem').text('Please select atleast one Area');
                }
                else if (RRConfigVM.SelectedFactorList().length === 0) {
                    $('#valErrorRRItem').show();
                    $('#valErrorRRItem').text('Please select atleast one Factor Type');
                }
                else {
                    
                    addRRCategories(data);
             
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveAttribute() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }
        function saveRRItem(data, event) {
            try {
                $('#valErrorRRItem').hide();

                if (RRConfigVM.editableRRItem().RRItemName() === "") {
                    $('#valErrorRRItem').show();
                    $('#valErrorRRItem').text(RRConfigVM.SelectedMRRAreaName() +' Name is required.');
                }
                else if (!RRConfigVM.EditRRItemFlag() && RRConfigVM.SelectedAssessmentType().length === 0) {
                    $('#valErrorRRItem').show();
                    $('#valErrorRRItem').text('Please select atleast one Assessment Type');
                }
                else {
                    if (!RRConfigVM.EditRRItemFlag())
                        addRRItem(data);
                    else
                        editRRItem(data);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveAttribute() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function DrawMappingsTable(data) {
            try {
                for (var i = 0; i < RRConfigVM.selectedRATs().length; i++) {
                    RRConfigVM.SelectedAssessmentType().push(RRConfigVM.selectedRATs()[i]);
                }
                if (RRConfigVM.SelectedAssessmentType().length === 0) {
                    $('#MappingsTableDiv').hide();
                }
                else if (RRConfigVM.SelectedAssessmentType().length > 0) {
                    $('#MappingsTableDiv').show();
                    
                    var mListObjJS = ko.toJS(data.MasterAttributeList());


                    var mListObj = $.map(mListObjJS, function (result) {
                        return new MasterAttributeModel(result);
                    });

                    RRConfigVM.editableRRItem().MasterAttributeList([]);

                    mtableObj = $('#tblMapping').DataTable();
                    mtableObj.destroy();
                    $('#tblMapping tbody tr').remove();

                    RRConfigVM.editableRRItem().MasterAttributeList(mListObj);

                    var MappingsTableObj = $('#tblMapping').DataTable({
                        "order": [],
                        "aaSorting": [],
                        "bResponsive": true,
                        "aLengthMenu": [5, 10, 25, 50]
                    });
                    $('#tblMapping').DataTable().draw(false);

                    for (var i = 0; i < RRConfigVM.AssessmentTypeList().length; i++) {
                        var count = 0;
                        for (var j = 0; j < RRConfigVM.SelectedAssessmentType().length; j++) {
                            if (RRConfigVM.AssessmentTypeList()[i].AssessmentId() === RRConfigVM.SelectedAssessmentType()[j])
                                count++;
                        }
                        if (count === 0)
                            MappingsTableObj.column(RRConfigVM.AssessmentTypeList()[i].ColumnIndex()).visible(false);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DrawMappingsTable() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }
        
        function InitiateLevelTree() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {

                    url: "/api/RiskRatingConfiguration/GetAllAreasForRR",
                    type: "GET",
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    if (jsonResult.AreaLevelsData["#"] == undefined) {
                        $('#subfactor').hide();
                        $('#FilterAreaAccordion').hide();
                        $('#errorAreas').show();

                    }
                    else {
                        $('#errorAreas').hide();
                        $('#subfactor').show();
                        $('#FilterAreaAccordion').show();
                        //implement js tree logic here
                        RRConfigVM.AreaLeveljstree(jsonResult.AreaLevelsData);

                        var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                            return new jsTreeModel(result);
                        });

                        $('#jsTreeAreaLevel').treeview({
                            data: MappedJsTreeList,
                            onNodeSelected: nodeClickEvent
                        });

                        var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                        RRConfigVM.hasChildNodes(hasChildNodes);

                        //for initial load expand for treeview
                        $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                        $("loadingImgOrCalc").hide();
                        $("loadingMainImgDivTh").hide();
                        $("loadingImgMainTh").hide();

                    }
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }

            function filterJsTree(TreeStructure) {

                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes != undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }

                        if (item.showLevel == 1)
                            return true;
                        else
                            return false;

                    }
                );
            }


            function nodeClickEvent(event, node) {
                // Your logic goes here
                if (node.dead_node == 1) {
                    //select node explicitly in case of recursive calling activity.
                    $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);

                    RRConfigVM.CurrentRiskFactorId(parseInt(node.id));
                    $('#loadingMainImgDivFactors').show();
                    GetRiskSubFactors(parseInt(node.id));

                } else {
                    //recursively opening until the dead_node arrives.
                    if (!(node.state.expanded))
                        nodeClickEvent(event, node.nodes[0]);
                    $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                    $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);


                }
            }


                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                };
            }

            function jsTreeModel(item) {
                var self = this;

                self.id = item.AreaLevelId.toString();
                self.text = item.AreaLevelName;
                if (RRConfigVM.AreaLeveljstree()[self.id].length > 0) {
                    self.nodes = $.map(RRConfigVM.AreaLeveljstree()[self.id], function (result) {
                        return new jsTreeModel(result);
                    });
                }
                self.state = { expanded: false };
                self.dead_node = item.DeadNode;
                self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
                self.RA_Type = ko.observable(item.RA_Type);

        }

        function RiskSubFactorModel(item) {
            try {
                var self = this;
                self.RRSubFactorId = ko.observable(item.RRSubFactorId);
                self.RRSubFactorName = ko.observable(item.RRSubFactorName);
                self.RRSubFactorDescription = ko.observable(item.RRSubFactorDescription);
                self.RiskLevel = ko.observable($('<div/>').html(item.RiskLevel).text());
                self.ApplicableRATNamesRRSF = ko.observable(item.ApplicableRATNamesRRSF);
                self.ApplicableRATIdsRRSF = ko.observable(item.ApplicableRATIdsRRSF);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        };
        
        //#endregion


        //#region PopUps

        function addRRItemPopUp(data) {
            try {
                //GetAssessmentTypes();
                RRConfigVM.SelectedAreasList([]);
                RRConfigVM.SelectedFactorList([]);
                RRConfigVM.SelectedAssessmentType([]);
                RRConfigVM.RRAreaList([]);
                RRConfigVM.RRFactorList([]);
                $('#RRFactors').multiselect();
                $('#RRAreas').multiselect();

                $('#ModalAddRRItem').modal('show');
               
                $('#modalContent').css({
                    'margin-top': 'auto'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addRRItemPopUp() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function EditItemPopUp(data) {
            try {
                RRConfigVM.EditRRItemFlag(true);
                RRConfigVM.addPopUpCss(false);
                RRConfigVM.popUpTitle("Edit " + RRConfigVM.SelectedMRRAreaName());
                RRConfigVM.ClickedRRItemId(data.RRItemId());
                RRConfigVM.selectedRATs([]);
                RRConfigVM.SelectedAssessmentType([]);
                var editRRItem = new RRItemModel({
                    RRItemId: data.RRItemId(), RRItemName: data.RRItemName(), RRItemDescription: data.RRItemDescription(),
                    RRItemOverallRank: data.RRItemOverallRank(), ApplicableRATNamesRRItems: data.ApplicableRATNamesRRItems(),
                    ApplicableRATIdsRRItems: data.ApplicableRATIdsRRItems(), RATArrayRRItems: data.RATArrayRRItems(),
                    MasterAttributeList: []
                });

                RRConfigVM.editableRRItem(editRRItem);

                var ATArray = [];
                for (var i = 0; i < RRConfigVM.AssessmentTypeList().length; i++) {
                    var count = 0;
                    for (var j = 0; j < data.RATArrayRRItems().length; j++) {
                        if (data.RATArrayRRItems()[j].AssessmentId.toString().trim() === RRConfigVM.AssessmentTypeList()[i].AssessmentId().toString().trim())
                            count++;
                    }
                    if (count === 0)
                        ATArray.push(RRConfigVM.AssessmentTypeList()[i]);
                    else
                        RRConfigVM.selectedRATs().push(RRConfigVM.AssessmentTypeList()[i].AssessmentId());
                }
                if (ATArray.length === 0) {
                    $('#RAApplicabilityEdit').hide();
                }
                else {
                    $('#RAApplicabilityEdit').show();
                    RRConfigVM.AssessmentTypeListEdit(ATArray);
                    $('#RAApplicabilityEdit').multiselect();
                }
                $('#RATApplicabilityText').empty();
                document.getElementById('RATApplicabilityText').innerHTML = data.ApplicableRATNamesRRItems();

                $('#MappingsTableDiv').show();
                $('#RAApplicability').multiselect();
                $('#ModalAddRRItem').modal('show');
                $('#modalContent').css({
                    'margin-top': 'auto'
                });
                DrawMappingsTable(data);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditItemPopUp() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function DeleteItemPopUp(data) {
            try {
                app.showMessage('Are you sure you want to delete this ' + RRConfigVM.SelectedMRRAreaName() + ' ?', 'Delete ' + RRConfigVM.SelectedMRRAreaName(), ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteRRItem(data.RRItemId());
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteItemPopUp() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion


        //#region Set Methods

        function addRRCategories(data) {
            try {
                var RATIDs = "";
                var AreaIDs = "";
                var FactorIDs = "";
                for (var i = 0; i < RRConfigVM.SelectedAssessmentType().length; i++) {
                    if (RATIDs === "")
                        RATIDs += RRConfigVM.SelectedAssessmentType()[i];
                    else
                        RATIDs += "," + RRConfigVM.SelectedAssessmentType()[i];
                }
                for (var i = 0; i < RRConfigVM.SelectedAreasList().length; i++) {
                    if (AreaIDs === "")
                        AreaIDs += RRConfigVM.SelectedAreasList()[i];
                    else
                        AreaIDs += "," + RRConfigVM.SelectedAreasList()[i];
                }
                for (var i = 0; i < RRConfigVM.SelectedFactorList().length; i++) {
                    if (FactorIDs === "")
                        FactorIDs += RRConfigVM.SelectedFactorList()[i];
                    else
                        FactorIDs += "," + RRConfigVM.SelectedFactorList()[i];
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/AddRRCategories",
                    type: "POST",
                    headers: headers,
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: (
                        {
                            SelectedRAT: RATIDs,
                            SelectedAreaId: AreaIDs,
                            SelectedFactorsId: FactorIDs
                        })
                })
                    .success(function (jsonResult, success) {

                        if (jsonResult > 1) {
                            logger.logSuccess('Mapped Areas & Factors Successfully.', 'Success', system.getModuleId(RRConfigVM), true);
                            $('#ModalAddRRItem').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            InitiateLevelTree();
                        }
                        else if (jsonResult == -3)
                            logger.logError('One or more areas already have factors setup in them.Please proceed without those areas.', 'Error', system.getModuleId(RRConfigVM), true);
                        else
                            logger.logError('An error occurred while performing the mapping operation. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addRRItem() method in RiskRatingConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addRRItem() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function addRRItem(data) {
            try {
                var RATIds = "";
                for (var i = 0; i < RRConfigVM.SelectedAssessmentType().length; i++) {
                    if (RATIds === "")
                        RATIds += RRConfigVM.SelectedAssessmentType()[i];
                    else
                        RATIds += "," + RRConfigVM.SelectedAssessmentType()[i];
                }
                var MappingsListObj = [];
                for (var i = 0; i < data.MasterAttributeList().length; i++) {
                    for (var j = 0; j < data.MasterAttributeList()[i].AttributeMappingsList().length; j++) {
                        MappingsListObj.push(new MapRRIAOModel({
                            RRA_ID: data.MasterAttributeList()[i].AttributeId(),
                            RAT_ID: data.MasterAttributeList()[i].AttributeMappingsList()[j].RATId_Mappings(),
                            AO_ID: data.MasterAttributeList()[i].AttributeMappingsList()[j].SelectedOptionId(),
                            INPUT_TYPE: data.MasterAttributeList()[i].AttributeMappingsList()[j].InputType_Mappings(),
                            AO_TEXT: data.MasterAttributeList()[i].AttributeMappingsList()[j].SelectedOptionText()
                        }));
                       
                    }
                }


                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/AddRRItem?MRRAId=" + parseInt(RRConfigVM.SelectedMRRAreaId()),
                    type: "POST",
                    headers: headers,
                    data: {
                        RRItemName: data.RRItemName(), RRItemDescription: data.RRItemDescription(), ApplicableRATIdsRRItems: RATIds,
                        MappingsListObj: MappingsListObj }
                })
                    .success(function (jsonResult, success) {

                        if (jsonResult === 1) {
                            logger.logSuccess('Add Operation performed Successfully.', 'Success', system.getModuleId(RRConfigVM), true);
                            $('#ModalAddRRItem').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetAllRRItemsWithMappings();
                        }
                        else
                            logger.logError('An error occurred while performing the add operation. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addRRItem() method in RiskRatingConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addRRItem() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function editRRItem(data) {
            try {
                var RATIds = "";
                for (var i = 0; i < RRConfigVM.SelectedAssessmentType().length; i++) {
                    var count = 0;
                    for (var j = 0; j < RRConfigVM.selectedRATs().length; j++) {
                        if (RRConfigVM.SelectedAssessmentType()[i] === RRConfigVM.selectedRATs()[j]) {
                            count++;
                        }
                    }
                    if (count === 0) {
                        if (RATIds === "")
                            RATIds += RRConfigVM.SelectedAssessmentType()[i];
                        else
                            RATIds += "," + RRConfigVM.SelectedAssessmentType()[i];
                    }
                }
                var MappingsListObj = [];
                for (var i = 0; i < data.MasterAttributeList().length; i++) {
                    for (var j = 0; j < data.MasterAttributeList()[i].AttributeMappingsList().length; j++) {
                        MappingsListObj.push(new MapRRIAOModel({
                            RRI_ID: data.RRItemId(),
                            RRA_ID: data.MasterAttributeList()[i].AttributeId(),
                            RAT_ID: data.MasterAttributeList()[i].AttributeMappingsList()[j].RATId_Mappings(),
                            AO_ID: data.MasterAttributeList()[i].AttributeMappingsList()[j].SelectedOptionId(),
                            INPUT_TYPE: data.MasterAttributeList()[i].AttributeMappingsList()[j].InputType_Mappings(),
                            AO_TEXT: data.MasterAttributeList()[i].AttributeMappingsList()[j].SelectedOptionText()
                        }));

                    }
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/EditRRItem",
                    type: "POST",
                    headers: headers,
                    data: {
                        RRItemId: data.RRItemId(), RRItemName: data.RRItemName(), RRItemDescription: data.RRItemDescription(),
                        ApplicableRATIdsRRItems: RATIds, MappingsListObj: MappingsListObj
                    }
                })
                    .success(function (jsonResult, success) {

                        if (jsonResult === 1) {
                            logger.logSuccess('Edit Operation performed Successfully.', 'Success', system.getModuleId(RRConfigVM), true);
                            $('#ModalAddRRItem').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetAllRRItemsWithMappings();
                        }
                        else
                            logger.logError('An error occurred while performing the edit operation. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addRRItem() method in RiskRatingConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: editRRItem() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion


        //#region Delete Methos

        function DeleteRRItem(RRItemId) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/DeleteRRItem?RRItemId=" + RRItemId,
                    type: "POST",
                    headers: headers
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult > 0) {
                            logger.logSuccess(RRConfigVM.SelectedMRRAreaName() + ' has been deleted Successfully.', 'Success', system.getModuleId(RRConfigVM), true);
                            GetAllRRItemsWithMappings();
                        }
                        else
                            logger.logError('An error occurred while deleting the ' + RRConfigVM.SelectedMRRAreaName() + '. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteRRItem() method in RiskRatingConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteRRItem() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }


        //#endregion

        //#region Model Definitions

        function RRItemModel(item) {
            try {
                var self = this;
                self.RRItemId = ko.observable(item.RRItemId);
                self.RRItemName = ko.observable(item.RRItemName);
                self.RRItemDescription = ko.observable(item.RRItemDescription);
                self.RRItemOverallRank = ko.observable(item.RRItemOverallRank);
                self.ApplicableRATNamesRRItems = ko.observable(item.ApplicableRATNamesRRItems);
                self.ApplicableRATIdsRRItems = ko.observable(item.ApplicableRATIdsRRItems);
                self.RATArrayRRItems = ko.observable(item.RATArrayRRItems);
                var MappedListMA = $.map(item.MasterAttributeList, function (result) {
                    return new MasterAttributeModel(result);
                });
                self.MasterAttributeList = ko.observable(MappedListMA);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRItemModel() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function MasterAttributeModel(item) {
            try {
                var self = this;
                self.AttributeId = ko.observable(item.AttributeId);
                self.AttributeName = ko.observable(item.AttributeDescription);
                self.AttributeDescription = ko.observable(item.AttributeDescription);
                self.InputType = ko.observable(item.InputType);
                var MappedListAM = $.map(item.AttributeMappingsList, function (result) {
                    return new AttributeMappingsModel(result);
                });
                self.AttributeMappingsList = ko.observable(MappedListAM);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: MasterAttributeModel() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function AttributeMappingsModel(item) {
            try {
                var self = this;
                self.AttributeId_Mappings = ko.observable(item.AttributeId_Mappings);
                self.RRItemId_Mappings = ko.observable(item.RRItemId_Mappings);
                self.RATId_Mappings = ko.observable(item.RATId_Mappings);
                self.Is_Applicable = ko.observable(item.Is_Applicable);
                self.InputType_Mappings = ko.observable(item.InputType_Mappings);
                self.SelectedOptionId = ko.observable(item.SelectedOptionId);
                self.SelectedOptionText = ko.observable(item.SelectedOptionText);
                var MappedListAO = $.map(item.OptionsList, function (result) {
                    return new OptionsModel(result);
                });
                self.OptionsList = ko.observable(MappedListAO);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AttributeMappingsModel() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }
       
        function OptionsModel(item) {
            try {
                var self = this;
                self.AttributeId_Options = ko.observable(item.AttributeId_Options);
                self.RATIdOptions = ko.observable(item.RATIdOptions);
                self.OptionId = ko.observable(item.OptionId);
                self.OptionName = ko.observable(item.OptionName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OptionsModel() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function AssessmentTypeModel(item) {
            try {
                var self = this;
                self.AssessmentId = ko.observable(item.AssessmentId);
                self.AssessmentDisplayName = ko.observable(item.AssessmentDisplayName);
                self.SelectedAreaId = ko.observable(item.SelectedAreaId);
                //var selectedRiskIds = [];
                //if (item.SelectedAreaId == 1) {
                //    selectedRiskIds.push(item.AssessmentId);
                //}

              
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentTypeModel() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function MapRRIAOModel(item) {
            try {
                var self = this;
                self.RRI_ID = ko.observable(item.RRI_ID);
                self.RRA_ID = ko.observable(item.RRA_ID);
                self.RAT_ID = ko.observable(item.RAT_ID);
                self.AO_ID = ko.observable(item.AO_ID);
                self.INPUT_TYPE = ko.observable(item.INPUT_TYPE);
                self.AO_TEXT = ko.observable(item.AO_TEXT);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentTypeModel() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

    });
